import { gql } from '@apollo/client';

export default gql`
  query place($id: ID!) {
    space {
      overInspectionsLimit
      adminRole
    }
    place(id: $id) {
      id
      name
      street
      city
      zipCode
      phone
      email
      contactPerson
      notes
      inspectionSubjectsTotal
      inspectionsTotal
      incomingInspectionsTotal
      overdueInspectionsTotal
      pendingInspectionsTotal
      complianceRatio
      createdAt
    }
  }
`;
